module.exports = __webpack_public_path__ + "static/media/game-bosstalking.bbcecce6.png";